import { render } from "./ProductsDetailsTabs.vue?vue&type=template&id=7811dbae&ts=true"
import script from "./ProductsDetailsTabs.vue?vue&type=script&lang=ts"
export * from "./ProductsDetailsTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__